'use client';
import merge from 'lodash.merge';
import { ThemeProvider as Provider } from 'styled-components';

import palette from './palette';
import defaultBreakPoint, { mediaQueries } from './breakPoint';
import { Theme } from './types';

const uiKitTheme: Theme = {
  palette,
  breakPoint: defaultBreakPoint,
  mediaQueries,
};

// breakPoint kontrolü ve eksikse hata fırlatma
function validateBreakPoints(custom: Partial<typeof defaultBreakPoint>) {
  if (!custom.DESKTOP) {
    throw new Error('breakPoint.DESKTOP is undefined');
  }

  return { ...defaultBreakPoint, ...custom }; // Eksik olanları default'tan alır
}

export const ThemeProvider = ({
  children,
  theme,
}: React.PropsWithChildren<{ theme?: Partial<Theme> }>) => {
  const safeBreakPoint = theme?.breakPoint
    ? validateBreakPoints(theme.breakPoint)
    : defaultBreakPoint;

  const extendedTheme = merge({}, uiKitTheme, theme, {
    breakPoint: safeBreakPoint,
  });

  return <Provider theme={extendedTheme}>{children}</Provider>;
};

export default uiKitTheme;
